/**
 * Program Benefits 1063 — KUK "Why Choose Us?".
 *
 * Icon / title / description cards as a horizontal rail from 768px up and a
 * two-column grid below it, with a lead-form CTA beside the heading on desktop and at
 * the foot on mobile. Ported from kuk-campus-portal `components/Degree/KeyBenefits.tsx`.
 *
 * Every field maps to a column that already exists on `program_benefits` — the
 * variant adds no schema of its own beyond widening `program_benefits.variant`.
 */

export const PROGRAM_BENEFITS_1063_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Benefit cards",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_icon: "",
    meta_title: "",
    meta_sub_title: "",
    meta_priority: 1,
    meta_status: true,
  },

  PROGRAM_BENEFITS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Why Choose Us?",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Why Choose Us?",
      defaultValue: "Why Choose Us?",
    },
    {
      fieldName: "title_start_color",
      label: "Heading colour",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#101112",
    },
    {
      fieldName: "title_end_color",
      label: "Heading rule colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      description: "The bar under the heading.",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "desktop_background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "card_hover_background_color",
      label: "Card background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_1",
      label: "Card icon colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      description: "Applies to icon-key icons; uploaded images keep their own colours.",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "subtitle_color",
      label: "Card title colour",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#101112",
    },
    {
      fieldName: "description_color",
      label: "Card description colour",
      value: "#4B4B4B",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#4B4B4B",
    },
    {
      fieldName: "button_text",
      label: "CTA text (opens the lead form popup)",
      value: "Get in touch",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Get in touch",
    },
    {
      fieldName: "button_icon_url",
      label: "CTA icon",
      value: "chat",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — upload, or type an icon name",
      defaultValue: "chat",
    },
    {
      fieldName: "button_color",
      label: "CTA background colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "button_text_color",
      label: "CTA text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "meta_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload an icon, or type an icon name",
      description: "Accepts an uploaded image URL OR a built-in icon name such as tutor, support, graph.",
      defaultValue: "",
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Expert Guidance",
      defaultValue: "",
    },
    {
      header: "Description",
      fieldName: "meta_sub_title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      rows: 3,
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS_1: [],
};
